// getInstalledPlugins returns a list of plugins installed to the given 
// form source
export const getInstalledPlugins = (fields: any[], plugins: any[]) => {
  for (let field of fields) {
    const isPresent = plugins.find((el) => el.name === field.pluginName)

    if (!isPresent) {
      plugins.push({
        name: field.pluginName,
        url: field.pluginUrl,
      })
    }

    if (field && field.fields && field.fields.length) {
      getInstalledPlugins(field.fields, plugins)
    }
  }

  return plugins.filter((plugin) => plugin.url)
}
